// src/index.js
// App entry point. Initialises MSAL before rendering anything.
// This handles any redirect response coming back from Azure AD.

import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider, initializeMsal } from "./auth/authProvider";
import App from "./App";

async function bootstrap() {
  // MUST initialise MSAL before rendering — handles redirect callbacks
  await initializeMsal();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
}

bootstrap();
